/* Produktlister for merkesider, samlingssider og forsiden.
   Data hentes fra /collections/<handle>?view=merkedata (templates/collection.merkedata.liquid).

   Monteringspunkter:
   [data-bt-grid]   data-samling, data-sort, data-filtre ("typer" | "sidepanel"), data-grense
   [data-bt-topp]   data-samling, data-antall: de mest kjoepte, uten filtre
   [data-bt-best]   data-samlinger="a,b,c": bestselgere fordelt paa flere samlinger;
                    data-utvalg=<id> peker paa JSON med haandplukkede varer
   [data-bt-collage] data-samling, data-antall: produktbilder til toppfelt */
(() => {
  if (window.__btButikk) return;
  window.__btButikk = true;

  const S = window.BYUTI_SOK || {};
  const GODKJENT = new Set((S.merker || []).map((m) => String(m).toLowerCase()));
  const mva = S.inklMva ? 'inkl. mva' : 'eks. mva';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const kr = (oere) => new Intl.NumberFormat('nb-NO',
    { minimumFractionDigits: oere % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(oere / 100) + ' kr';

  /* Produkttype -> kategori i filteret (ryddet 20.10.2026, se BYUTI produkttyper
     forslag 2026-10-20.xlsx). Nye typer maa legges inn her, ellers vises typen som egen kategori. */
  const GRUPPE = {
    'Klassiske vipper': 'Vipper', 'Volumvipper': 'Vipper', 'Ferdige volumvifter': 'Vipper', 'Easy fan vipper': 'Vipper', 'Brune vipper': 'Vipper', 'Fargevipper': 'Vipper', 'Treningsvipper': 'Vipper',
    'Lim': 'Lim og primer', 'Limfjerner': 'Lim og primer', 'Primer': 'Lim og primer',
    'Vipperens': 'Vipperens og preparering', 'Rensepads': 'Vipperens og preparering', 'Saltvannsløsning': 'Vipperens og preparering',
    'Teip og øyepads': 'Pads og teip',
    'Pinsett': 'Pinsetter',
    'Lash Filler': 'Vippeløft og brynsløft', 'Brow Bomber': 'Vippeløft og brynsløft', 'Silikonskjold': 'Vippeløft og brynsløft',
    'Farge': 'Bryn og farge', 'Bryn': 'Bryn og farge', 'Oppmåling': 'Bryn og farge', 'Vippe- og brynserum': 'Bryn og farge', 'Maskara': 'Bryn og farge',
    'Filmvoks': 'Voks', 'Rullevoks': 'Voks', 'Spatelvoks': 'Voks', 'Sukkervoks': 'Voks', 'Voks': 'Voks',
    'Før voksing': 'Før og etter voksing', 'Etter voksing': 'Før og etter voksing', 'Talkum': 'Før og etter voksing',
    'Voksvarmer': 'Voksvarmere og vokstilbehør', 'Spatel': 'Voksvarmere og vokstilbehør', 'Strips': 'Voksvarmere og vokstilbehør', 'Vokstilbehør': 'Voksvarmere og vokstilbehør',
    'Ansiktsrens': 'Ansiktspleie', 'Toner': 'Ansiktspleie', 'Serum': 'Ansiktspleie', 'Ansiktskrem': 'Ansiktspleie', 'Øyekrem': 'Ansiktspleie', 'Ansiktsolje': 'Ansiktspleie', 'Sminkefjerner': 'Ansiktspleie', 'Ansiktsskrubb': 'Ansiktspleie',
    'Ansiktsmaske': 'Masker og plaster', 'Øyemaske': 'Masker og plaster', 'Kviseplaster': 'Masker og plaster', 'Nesestrips': 'Masker og plaster', 'Håndmaske': 'Masker og plaster', 'Fotmaske': 'Masker og plaster',
    'Kroppssåpe': 'Kroppspleie', 'Body lotion': 'Kroppspleie', 'Kroppsolje': 'Kroppspleie', 'Kroppsskrubb': 'Kroppspleie', 'Håndsåpe': 'Kroppspleie', 'Håndkrem': 'Kroppspleie', 'Deodorant': 'Kroppspleie', 'Solbeskyttelse ansikt': 'Kroppspleie', 'Solbeskyttelse kropp': 'Kroppspleie', 'Lip balm': 'Kroppspleie', 'Mammapleie': 'Kroppspleie', 'Fotskrubb': 'Kroppspleie', 'Neglebåndsolje': 'Kroppspleie',
    'Sjampo': 'Hår', 'Balsam': 'Hår', '2-i-1 sjampo og balsam': 'Hår', 'Hårpleie': 'Hår', 'Hårolje': 'Hår', 'Hårkur': 'Hår', 'Hårbøyle': 'Hår', 'Hårstrikk': 'Hår', 'Hårklype': 'Hår', 'Hårspenne': 'Hår', 'Hårbørste': 'Hår', 'Kam': 'Hår', 'Hårtilbehør': 'Hår',
    'Hudpleieverktøy': 'Hudpleieverktøy', 'Massasjesteiner': 'Hudpleieverktøy',
    'Parfyme': 'Duft og interiør', 'Diffuser': 'Duft og interiør', 'Te': 'Duft og interiør',
    'Rengjøring hjem': 'Hjem og rengjøring', 'Klesvask': 'Hjem og rengjøring', 'Oppvask': 'Hjem og rengjøring', 'Kjæledyrpleie': 'Hjem og rengjøring', 'Luktabsorber': 'Hjem og rengjøring', 'Våtservietter': 'Hjem og rengjøring',
    'Drillbits': 'Negl', 'Negledekor': 'Negl', 'Neglefil': 'Negl', 'Neglevifte': 'Negl', 'Løsnegler og tips': 'Negl', 'Neglepensler': 'Negl', 'Negleverktøy': 'Negl', 'Neglerens': 'Negl',
    'Engangsartikler': 'Forbruk og hygiene', 'Engangshansker': 'Forbruk og hygiene', 'Benkepapir': 'Forbruk og hygiene', 'Hygiene': 'Forbruk og hygiene', 'Desinfisering': 'Forbruk og hygiene',
    'Lampe': 'Utstyr og møbler', 'Stol': 'Utstyr og møbler', 'Behandlingsbenk': 'Utstyr og møbler', 'Trillebord': 'Utstyr og møbler', 'Sterilisator': 'Utstyr og møbler', 'Elektronikk': 'Utstyr og møbler', 'Tekstiler': 'Utstyr og møbler',
    'Tilbehør': 'Tilbehør og organisering', 'Organisering': 'Tilbehør og organisering', 'Pensler': 'Tilbehør og organisering', 'Verktøy': 'Tilbehør og organisering',
    'Startpakke': 'Startpakker og kit', 'Produktpakke': 'Startpakker og kit', 'Hudpleiekit': 'Startpakker og kit', 'Sminkekit': 'Startpakker og kit',
    'Salongstørrelse': 'Salongstørrelser',
    'Til videresalg': 'Til videresalg',
    'Markedsmateriell': 'Markedsmateriell og display', 'Display': 'Markedsmateriell og display', 'Gaveemballasje': 'Markedsmateriell og display', 'Uniform': 'Markedsmateriell og display',
    'Armbånd': 'Smykker',
    'Kurs': 'Kurs og arrangementer', 'Arrangement': 'Kurs og arrangementer', 'Bok': 'Kurs og arrangementer'
  };
  const gruppe = (p) => GRUPPE[p.type] || p.type || 'Annet';

  /* ── Data ─────────────────────────────────────────────────────── */
  const cache = {};
  function pakk(p, rang) {
    const varianter = p.x.map((v) => ({ id: v[0], tittel: v[1] === 'Default Title' ? '' : v[1], sku: v[2] || '', pris: v[3], forpris: v[4], ledig: v[5] === 1 }));
    return {
      id: p.i, tittel: p.t, handle: p.h, merke: p.v, type: p.y, kort: p.k, bilde: p.b, rang, opsjoner: p.o || [], kvantum: !!p.q,
      laast: !!p.l, tilgang: !p.l || GODKJENT.has(String(p.v).toLowerCase()),
      varianter, ledig: varianter.some((v) => v.ledig),
      pris: Math.min(...varianter.map((v) => v.pris))
    };
  }
  function hent(handle, sort) {
    const n = handle + '|' + (sort || '');
    if (cache[n]) return cache[n];
    cache[n] = (async () => {
      const url = (side) => '/collections/' + encodeURIComponent(handle) + '?view=merkedata&page=' + side +
        (sort ? '&sort_by=' + encodeURIComponent(sort) : '');
      const forste = await fetch(url(1), { credentials: 'same-origin' }).then((r) => r.json());
      const sider = [forste];
      const rest = [];
      for (let s = 2; s <= forste.sider; s++) rest.push(fetch(url(s), { credentials: 'same-origin' }).then((r) => r.json()));
      (await Promise.all(rest)).forEach((d) => sider.push(d));
      return [].concat(...sider.map((d) => d.p)).map(pakk);
    })();
    cache[n].catch(() => { delete cache[n]; });
    return cache[n];
  }

  const VARIANTKART = {};

  /* ── Variantvindu: aapnes fra «Velg variant» ── */
  function variantVindu(p) {
    let v = document.getElementById('bt-varianter');
    if (!v) {
      v = document.createElement('div'); v.id = 'bt-varianter'; v.className = 'bt-vv'; v.hidden = true;
      v.innerHTML = '<div class="bt-vv__bak" data-vv-lukk></div><div class="bt-vv__panel" role="dialog" aria-modal="true"><div class="bt-vv__topp"></div><div class="bt-vv__filtre"></div><div class="bt-vv__liste"></div></div>';
      document.body.appendChild(v);
    }
    v.querySelector('.bt-vv__topp').innerHTML = (p.bilde ? '<img src="' + esc(p.bilde) + '" alt="">' : '') +
      '<div><small>' + esc(p.merke) + '</small><b>' + esc(p.tittel) + '</b><span>' + p.varianter.length + ' varianter · priser ' + mva + '</span></div>' +
      '<button type="button" class="bt-vv__lukk" data-vv-lukk aria-label="Lukk">✕</button>';
    /* Filtre på produktets valg (f.eks. tykkelse, curl, lengde), så lange variantlister blir håndterbare */
    const deler = (x) => x.tittel.split(' / ');
    const valg = (p.opsjoner || []).map((navn, i) => {
      const verdier = [...new Set(p.varianter.map((x) => deler(x)[i]).filter(Boolean))];
      /* Tall i stigende rekkefølge (6, 7 … 17), deretter tekst som «Mixbrett» i opprinnelig rekkefølge */
      const tall = (t) => /^\d+([.,]\d+)?$/.test(t.trim()) ? parseFloat(t.replace(',', '.')) : NaN;
      verdier.sort((a, b) => { const x = tall(a), y = tall(b); if (isNaN(x) && isNaN(y)) return 0; if (isNaN(x)) return 1; if (isNaN(y)) return -1; return x - y; });
      return { navn, i, verdier };
    }).filter((o) => o.verdier.length > 1);
    const valgt = {}; let bareLager = false;
    const filterEl = v.querySelector('.bt-vv__filtre');
    filterEl.hidden = !(valg.length && p.varianter.length > 6);
    function tegnListe() {
      const synlig = p.varianter.filter((x) => (!bareLager || x.ledig) && valg.every((o) => !valgt[o.i] || deler(x)[o.i] === valgt[o.i]));
      /* Som på produktsiden: valgt verdi ved navnet, og strek over verdier som ikke finnes eller er utsolgt
         sammen med de andre valgene */
      const passerAndre = (x, i) => valg.every((o) => o.i === i || !valgt[o.i] || deler(x)[o.i] === valgt[o.i]);
      const status = (i, t) => {
        const treff = p.varianter.filter((x) => deler(x)[i] === t && passerAndre(x, i));
        return !treff.length ? 'finnes-ikke' : treff.some((x) => x.ledig) ? '' : 'utsolgt';
      };
      filterEl.innerHTML = valg.map((o) => '<div class="bt-vv__valg"><span>' + esc(o.navn) + (valgt[o.i] ? '<em>' + esc(valgt[o.i]) + '</em>' : '') + '</span><div>' +
        o.verdier.map((t) => { const st = status(o.i, t); return '<button type="button" class="bt-vv__chip' + (valgt[o.i] === t ? ' bt-vv__chip--paa' : '') + (st ? ' bt-vv__chip--' + st : '') + '" data-vv-valg="' + o.i + '" data-verdi="' + esc(t) + '"' + (st ? ' title="' + (st === 'utsolgt' ? 'Utsolgt' : 'Finnes ikke med valgene over') + '"' : '') + '>' + esc(t) + '</button>'; }).join('') +
        '</div></div>').join('') +
        '<div class="bt-vv__filterbunn"><label><input type="checkbox" data-vv-lager' + (bareLager ? ' checked' : '') + '> Bare på lager</label><span>Viser ' + synlig.length + ' av ' + p.varianter.length + '</span>' +
        (Object.keys(valgt).length ? '<button type="button" data-vv-nullstill>Nullstill</button>' : '') + '</div>';
      v.querySelector('.bt-vv__liste').innerHTML = synlig.length ? synlig.map((x) => '<div class="bt-vv__rad' + (x.ledig ? '' : ' bt-vv__rad--tom') + '" data-variant="' + x.id + '">' +
        '<div><b>' + esc(x.tittel) + '</b><small>' + (x.sku ? esc(x.sku) + ' · ' : '') + (x.ledig ? 'På lager' : 'Utsolgt') + '</small></div>' +
        '<div class="bt-vv__pris">' + kr(x.pris) + '</div>' +
        (x.ledig ? '<div class="bt-kjop"><div class="bt-ant"><button type="button" data-m aria-label="Færre">−</button><input type="number" min="1" value="1" inputmode="numeric" aria-label="Antall"><button type="button" data-p aria-label="Flere">+</button></div>' +
          '<button type="button" class="bt-leggi" data-legg data-navn="' + esc(p.tittel + ' · ' + x.tittel) + '">Legg i kurv</button></div>' : '<div class="bt-vv__ute">Utsolgt</div>') +
        '</div>').join('') : '<p class="bt-vv__ingen">Ingen varianter passer valgene.</p>';
    }
    filterEl.onclick = (e) => {
      const c = e.target.closest('[data-vv-valg]');
      if (c) { const i = c.dataset.vvValg; valgt[i] = valgt[i] === c.dataset.verdi ? undefined : c.dataset.verdi; if (!valgt[i]) delete valgt[i]; tegnListe(); }
      if (e.target.closest('[data-vv-nullstill]')) { Object.keys(valgt).forEach((k) => delete valgt[k]); tegnListe(); }
    };
    filterEl.onchange = (e) => { if (e.target.matches('[data-vv-lager]')) { bareLager = e.target.checked; tegnListe(); } };
    tegnListe();
    v.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-velg]'); if (b && VARIANTKART[b.dataset.velg]) { variantVindu(VARIANTKART[b.dataset.velg]); return; }
    if (e.target.closest('[data-vv-lukk]')) { document.getElementById('bt-varianter').hidden = true; document.documentElement.style.overflow = ''; }
  });
  document.addEventListener('keydown', (e) => { const v = document.getElementById('bt-varianter'); if (e.key === 'Escape' && v && !v.hidden) { v.hidden = true; document.documentElement.style.overflow = ''; } });

  /* ── Produktkort ──────────────────────────────────────────────── */
  function kort(p, merkelapp) {
    const url = '/products/' + p.handle;
    const v = p.varianter.find((x) => x.ledig) || p.varianter[0];
    const flere = p.varianter.length > 1;
    let bunn;
    if (!p.tilgang) {
      bunn = '<a class="bt-laas" href="' + (S.innlogget ? '/pages/bli-partner?merke=' + encodeURIComponent(p.merke) + '#merker' : (S.loginUrl || '/account/login')) + '">' +
        '<svg width="11" height="11" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="9" fill="none" stroke="currentColor" stroke-width="2"/><path d="M8 11V8a4 4 0 018 0v3" fill="none" stroke="currentColor" stroke-width="2"/></svg>' +
        (S.innlogget ? 'Partnervare · søk om tilgang' : 'Logg inn som partner for pris') + '</a>';
    } else {
      if (flere) VARIANTKART[p.id] = p;
      bunn = '<div class="bt-bunn"><div class="bt-pris"><span data-pris>' + (flere && p.varianter.some((x) => x.pris !== v.pris) ? 'Fra ' + kr(p.pris) : kr(v.pris)) + '</span>' +
          (v.forpris > v.pris ? '<s>' + kr(v.forpris) + '</s>' : '') + '<small>' + mva + (flere ? ' · ' + p.varianter.length + ' varianter' : '') + '</small></div>' +
          '<div class="bt-lager' + (p.ledig ? '' : ' bt-lager--tom') + '"><i></i>' + (p.ledig ? 'På lager' : 'Utsolgt') + '</div></div>' +
        (p.ledig && flere ? '<div class="bt-kjop"><button type="button" class="bt-leggi bt-velg" data-velg="' + p.id + '">Velg variant (' + p.varianter.length + ')</button></div>' : '') +
        (p.ledig && !flere ? '<div class="bt-kjop"><div class="bt-ant"><button type="button" data-m aria-label="Færre">−</button><input type="number" min="1" value="1" inputmode="numeric" aria-label="Antall"><button type="button" data-p aria-label="Flere">+</button></div>' +
          '<button type="button" class="bt-leggi" data-legg>Legg i kurv</button></div>' : '') +
        /* Utsolgt: samme varsling som «Gi meg beskjed» (Omnisend) på produktsiden */
        (!p.ledig ? '<div class="bt-kjop"><a class="bt-varsle" href="' + url + '#varsle"><svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 16V11a6 6 0 0112 0v5l1.5 2h-15L6 16z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M10 20.5a2 2 0 004 0" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>Varsle meg</a></div>' : '');
    }
    return '<article class="bt-kort" data-variant="' + v.id + '">' +
      (window.b3FavKnapp ? window.b3FavKnapp(p.id, p.handle, 'b3-fav--kort') : '') +
      '<a class="bt-bilde" href="' + url + '">' + (p.bilde ? '<img src="' + esc(p.bilde) + '" alt="" loading="lazy" width="500" height="500">' : '') +
        (merkelapp ? '<span class="bt-merkelapp">' + esc(merkelapp) + '</span>' : '') +
        (p.kvantum ? '<span class="bt-kvantum" title="Lavere stykkpris når du kjøper flere">Kvantumsrabatt</span>' : '') + '</a>' +
      '<div class="bt-merke">' + esc(p.merke) + '</div>' +
      '<a class="bt-navn" href="' + url + '">' + esc(p.tittel) + '</a>' +
      '<p class="bt-kort__tekst">' + esc(p.kort) + '</p>' + bunn + '</article>';
  }

  /* Kurv, antall og variant. Lytter paa dokumentet, saa alle lister virker. */
  function toast(t) {
    let e = document.querySelector('.bt-toast');
    if (!e) { e = document.createElement('div'); e.className = 'bt-toast'; e.setAttribute('role', 'status'); document.body.appendChild(e); }
    e.textContent = t; e.classList.add('bt-toast--vis');
    clearTimeout(e._t); e._t = setTimeout(() => e.classList.remove('bt-toast--vis'), 2200);
  }
  document.addEventListener('click', async (e) => {
    const k = e.target.closest('.bt-kort, .bt-vv__rad');
    if (!k) return;
    const felt = k.querySelector('.bt-ant input');
    if (!felt && !e.target.closest('[data-legg]')) return;
    if (e.target.closest('[data-m]')) felt.value = Math.max(1, (+felt.value || 1) - 1);
    if (e.target.closest('[data-p]')) felt.value = (+felt.value || 1) + 1;
    const knapp = e.target.closest('[data-legg]');
    if (!knapp) return;
    const antall = Math.max(1, +felt.value || 1);
    knapp.disabled = true; knapp.textContent = 'Legger i …';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +k.dataset.variant, quantity: antall }] }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || 'Kunne ikke legge i kurven');
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((x) => x.json());
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      knapp.textContent = '✓ Lagt i kurv';
      toast(antall + ' × ' + (knapp.dataset.navn || k.querySelector('.bt-navn').textContent) + ' · kurven: ' + kr(cart.total_price));
    } catch (err) {
      knapp.textContent = 'Ikke nok på lager'; toast(err.message);
    }
    setTimeout(() => { knapp.disabled = false; knapp.textContent = 'Legg i kurv'; }, 1800);
  });
  document.addEventListener('change', (e) => {
    if (!e.target.classList.contains('bt-variant')) return;
    const k = e.target.closest('.bt-kort'); const o = e.target.selectedOptions[0];
    k.dataset.variant = o.value;
    k.querySelector('[data-pris]').textContent = kr(+o.dataset.pris);
  });

  /* ── Liste med filtre ─────────────────────────────────────────── */
  async function grid(rot) {
    const liste = rot.querySelector('[data-liste]') || rot;
    const filtreEl = rot.querySelector('[data-filterboks]');
    const antallEl = rot.querySelector('[data-antall]');
    const sortEl = rot.querySelector('[data-sortering]');
    const flereEl = rot.querySelector('[data-flere]');
    const modus = rot.dataset.filtre || '';
    const steg = +rot.dataset.grense || 24;
    let alle = [], vist = steg, valgt = { gruppe: new Set(), merke: new Set(), lager: false }, smaa = new Set();
    liste.innerHTML = '<p class="bt-melding">Henter produktene …</p>';

    async function last() {
      const sort = sortEl ? sortEl.value : (rot.dataset.sort || 'best-selling');
      try { alle = await hent(rot.dataset.samling, sort); } catch (e) {
        liste.innerHTML = '<p class="bt-melding">Fikk ikke hentet produktene. Last siden på nytt.</p>'; return;
      }
      /* Typer med en eller to varer samles i «Annet», ellers blir filteret bare stoey */
      const t = {}; alle.forEach((p) => { const g = gruppe(p); t[g] = (t[g] || 0) + 1; });
      smaa = new Set(Object.keys(t).filter((g) => t[g] < 3));
      /* Lenker fra megamenyen: #type=Lim velger gruppen typen hoerer til */
      velgFraHash(false);
      tegn();
      if (/type=|gruppe=/.test(location.hash)) velgFraHash(true);
    }
    /* Lenker fra megamenyen: #type=Lim velger gruppen og ruller ned til sortimentet,
       ogsaa naar man allerede staar paa merkesiden (hashchange) */
    function velgFraHash(rull) {
      const g = /gruppe=([^&]+)/.exec(location.hash);
      const m = /type=([^&]+)/.exec(location.hash);
      if ((!m && !g) || !alle.length) return;
      if (g) valgt.gruppe = new Set([decodeURIComponent(g[1].replace(/\+/g, ' '))]);
      else {
        const type = decodeURIComponent(m[1].replace(/\+/g, ' '));
        const p = alle.find((x) => x.type === type);
        if (p) valgt.gruppe = new Set([grp(p)]);
      }
      if (rull) { vist = steg; tegn(); const mal = rot.closest('section') || rot; setTimeout(() => window.scrollTo({ top: mal.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }), 350); }
    }
    window.addEventListener('hashchange', () => velgFraHash(true));
    const grp = (p) => smaa.has(gruppe(p)) ? 'Annet' : gruppe(p);
    const passer = (p, utenom) =>
      (utenom === 'gruppe' || !valgt.gruppe.size || valgt.gruppe.has(grp(p))) &&
      (utenom === 'merke' || !valgt.merke.size || valgt.merke.has(p.merke)) &&
      (!valgt.lager || p.ledig);
    const tell = (felt, fn) => {
      const t = {}; alle.filter((p) => passer(p, felt)).forEach((p) => { const k = fn(p); t[k] = (t[k] || 0) + 1; });
      return Object.entries(t).sort((a, b) => (a[0] === 'Annet') - (b[0] === 'Annet') || b[1] - a[1]);
    };

    function tegnFiltre() {
      if (!filtreEl) return;
      if (modus === 'typer') {
        const g = tell('gruppe', grp);
        filtreEl.innerHTML = g.length < 2 ? '' : '<button type="button" class="bt-chip' + (valgt.gruppe.size ? '' : ' bt-chip--on') + '" data-g="">Alle <span>' + alle.length + '</span></button>' +
          g.map(([k, n]) => '<button type="button" class="bt-chip' + (valgt.gruppe.has(k) ? ' bt-chip--on' : '') + '" data-g="' + esc(k) + '">' + esc(k) + ' <span>' + n + '</span></button>').join('');
        return;
      }
      const boks = (felt, navn, rader) => (rader.length < 2 && !valgt[felt].size) ? '' :
        '<fieldset><legend>' + navn + '</legend>' + rader.map(([k, n]) =>
          '<label><input type="checkbox" data-f="' + felt + '" value="' + esc(k) + '"' + (valgt[felt].has(k) ? ' checked' : '') + '><span>' + esc(k) + '</span><em>' + n + '</em></label>').join('') + '</fieldset>';
      filtreEl.innerHTML = boks('gruppe', 'Produkttype', tell('gruppe', grp)) + boks('merke', 'Merke', tell('merke', (p) => p.merke)) +
        '<fieldset><legend>Lager</legend><label><input type="checkbox" data-f="lager"' + (valgt.lager ? ' checked' : '') + '><span>Bare varer på lager</span></label></fieldset>';
    }

    function tegn() {
      tegnFiltre();
      const utvalg = alle.filter((p) => passer(p));
      /* Varer kunden faar kjoept foerst, partnervarer uten tilgang sist */
      utvalg.sort((a, b) => (b.tilgang - a.tilgang) || (b.ledig - a.ledig) || 0);
      if (antallEl) antallEl.textContent = utvalg.length + (utvalg.length === 1 ? ' produkt' : ' produkter');
      liste.innerHTML = utvalg.length ? utvalg.slice(0, vist).map((p) => kort(p)).join('') :
        '<p class="bt-melding">' + (alle.length ? 'Ingen produkter passer filteret.' : 'Produktene kommer snart.') + '</p>';
      if (flereEl) flereEl.hidden = utvalg.length <= vist;
    }

    if (filtreEl) {
      filtreEl.addEventListener('click', (e) => {
        const b = e.target.closest('[data-g]'); if (!b) return;
        valgt.gruppe = new Set(b.dataset.g ? [b.dataset.g] : []); vist = steg; tegn();
      });
      filtreEl.addEventListener('change', (e) => {
        const f = e.target.dataset.f; if (!f) return;
        if (f === 'lager') valgt.lager = e.target.checked;
        else if (e.target.checked) valgt[f].add(e.target.value); else valgt[f].delete(e.target.value);
        vist = steg; tegn();
      });
    }
    if (sortEl) sortEl.addEventListener('change', () => { vist = steg; last(); });
    if (flereEl) flereEl.addEventListener('click', () => { vist += steg; tegn(); });
    const apne = rot.querySelector('[data-apne-filtre]');
    if (apne && filtreEl) apne.addEventListener('click', () => filtreEl.classList.toggle('bt-filtre--apen'));
    last();
  }

  async function toppListe(rot) {
    try {
      const l = (await hent(rot.dataset.samling, 'best-selling')).filter((p) => p.bilde && !/tester|kurs/i.test(p.tittel));
      const n = +rot.dataset.antall || 4;
      rot.innerHTML = l.slice(0, n).map((p, i) => kort(p, i === 0 ? 'Bestselger' : '')).join('');
    } catch (e) { rot.innerHTML = ''; }
  }

  async function bestselgere(rot) {
    const samlinger = (rot.dataset.samlinger || '').split(',').map((s) => s.trim()).filter(Boolean);
    const n = +rot.dataset.antall || 8;
    /* Haandplukkede varer (produktliste i temaet) gaar foran salgstallene */
    const valgtEl = rot.dataset.utvalg && document.getElementById(rot.dataset.utvalg);
    if (valgtEl) {
      try {
        const valgt = JSON.parse(valgtEl.textContent).map(pakk).filter((p) => p.bilde);
        if (valgt.length) { rot.innerHTML = valgt.slice(0, n).map((p) => kort(p, '')).join(''); return; }
      } catch (e) { /* faller tilbake paa bestselgere */ }
    }
    try {
      const lister = await Promise.all(samlinger.map((h) => hent(h, 'best-selling').catch(() => [])));
      const ut = [], brukt = new Set();
      for (let runde = 0; ut.length < n && runde < 10; runde++) {
        for (const l of lister) {
          const p = l.filter((x) => x.bilde && !brukt.has(x.id) && !/tester|kurs|kalender/i.test(x.tittel))[0];
          if (p && ut.length < n) { brukt.add(p.id); ut.push(p); }
        }
      }
      rot.innerHTML = ut.map((p, i) => kort(p, i === 0 && rot.dataset.merkelapp ? rot.dataset.merkelapp : (rot.dataset.merkelapp ? '' : 'Bestselger'))).join('');
    } catch (e) { rot.innerHTML = ''; }
  }

  async function collage(rot) {
    try {
      const l = (await hent(rot.dataset.samling, 'best-selling')).filter((p) => p.bilde && !/tester|kurs|kalender/i.test(p.tittel));
      rot.innerHTML = l.length
        ? l.slice(0, +rot.dataset.antall || 3).map((p) => '<div><img src="' + esc(p.bilde) + '" alt="" loading="lazy"></div>').join('')
        : '<div class="bt-kommer">Kommer snart</div>';
    } catch (e) { /* toppfeltet blir staaende tomt */ }
  }

  /* Produktgruppene i en samling, slik merkesiden viser dem (brukes av megamenyen) */
  async function grupper(handle) {
    const l = await hent(handle, 'best-selling');
    const t = {}; l.forEach((p) => { const g = gruppe(p); t[g] = (t[g] || 0) + 1; });
    const ut = {}; Object.entries(t).forEach(([g, n]) => { const k = n < 3 ? 'Annet' : g; ut[k] = (ut[k] || 0) + n; });
    return Object.entries(ut).sort((a, b) => (a[0] === 'Annet') - (b[0] === 'Annet') || b[1] - a[1]);
  }
  window.btKort = { kort, pakk, grupper };

  const start = () => {
    document.querySelectorAll('[data-bt-grid]').forEach(grid);
    document.querySelectorAll('[data-bt-topp]').forEach(toppListe);
    document.querySelectorAll('[data-bt-best]').forEach(bestselgere);
    document.querySelectorAll('[data-bt-collage]').forEach(collage);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
